<template lang="pug">
  el-aside(:class="toggle(isCollapse)" width="none")
    p.toggle
      a.toggle(@click="isCollapse=isCollapse==true?false:true" :class="toggle(isCollapse)")
    p.cuona-logo(:class="toggle(isCollapse)")
    p.cuona-nolabel-logo(:class="toggle(isCollapse)")

    el-menu(:collapse="isCollapse" :default-openeds="['1','2']" style="width:auto")
      template(v-for="(menu, i) in menus")
        el-menu-item(v-if="matchMenuAndRole(i) && menu.submenus.length === 0" :index="String(i)" style="padding-left:0px;" v-intro="$t(menu.intro)" v-intro-highlight-class="'highlightBg'" v-intro-disable-interaction="false")
          router-link(:to="{path: menu.path}")
            i.menu-icon(:class="menu.name")
            span {{ $t(menu.title) }}
        el-submenu(v-else-if="matchMenuAndRole(i)" :index="String(i)" v-intro="$t(menu.intro)" v-intro-highlight-class="'highlightBg'" v-intro-disable-interaction="false")
          div(slot="title")
            i.menu-icon(:class="menu.name")
            span {{ $t(menu.title) }}
          el-menu-item(v-for="(submenu, j) in menu.submenus" :index="i+'-'+j" :key="j")
            router-link(@click.native="resetAnalysisFilters(submenu.path)" :to="{path: submenu.path}") {{ $t(submenu.title) }}
</template>

<script>
export default {
  data () {
    return {
      isCollapse: false,
      menus: [
        {
          name: "icon-dashboard",
          path: "/dashboard",
          title: 'menus.dashboard',
          submenus: [],
          roles: ["admin","distributor","owner","manager"],
          intro: "Guide.sideBar_guide01"
        },
        {
          name: "icon-analysis",
          title: 'menus.analytics',
          submenus: [
            {
              path: "/analysis/user",
              title: 'menus.user'
            },
            {
              path: "/analysis/event",
              title: 'menus.event'
            },
            {
              path: "/analysis/device",
              title: 'menus.device'
            }
          ],
          roles: ["admin","distributor","owner","manager"],
          intro: "Guide.sideBar_guide02"
        },
        {
          name: "icon-cuona",
          title: 'menus.cuona',
          submenus: [
            {
              path: "/cuona/device",
              title: 'menus.devices'
            },
            {
              path: "/cuona/group",
              title: 'menus.group'
            },
            {
              path: "/cuona/event",
              title: 'menus.event'
            }
          ],
          roles: ["admin","distributor","owner","manager"],
          intro: "Guide.sideBar_guide03"
        }
      ]
    }
  },
  computed: {
    role() {
      return this.$store.state.user.user.role;
    }
  },
  watch: {
    isCollapse: {
      handler() {
        localStorage.isCollapse = this.isCollapse ? "none" : "show";
      },
    }
  },
  created() {
    if (localStorage.isCollapse) {
      this.isCollapse = localStorage.isCollapse == "none";
    }
  },
  methods: {

    // 表示するmenuがroleと一致していたらtrueを返す
    matchMenuAndRole(index) {
      return this.menus[index].roles.indexOf(this.role) >= 0
    },
    toggle(collapse) {
      return collapse == true ? "show" : "none"
    },
    resetAnalysisFilters(path) {
      if(path.indexOf('/analysis/') === -1) {
        this.$store.commit('resetAnalysisFilters');
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-aside {
  background: #000;
  width: 240px;
  max-width: 240px;
  min-width: 64px;
  overflow: hidden !important;
  transition: width .4s ease-in-out;

  &.show {
    width: 64px;
  }

  p {
    text-align: right;
    &.toggle {
      margin-top: 0;
    }
    a.toggle {
      display: inline-block;
      width: 32px;
      height: 32px;
      background: url("../assets/toggle_button.svg") no-repeat center;
      transition: all .3s ease-in;

      &.show {
        text-align: center;
        width: 64px;
      }
      &.none {
        text-align: right;
        width: 32px;
      }
      &:hover {
        background-color: rgba(255,255,255,0.2);
        color: rgba(255,255,255,1.0);
      }
    }
  }
  p.cuona-logo {
    display: block;
    width: 240px;
    height: 100px;
    max-height: 100px;
    min-height: 45px;
    margin: 0 auto 40px auto;
    background: url("../assets/cuona_logo.svg") no-repeat center;
    transition: all .3s ease-in;

    &.show {
      transform: translateX(-80px) scale(0.8);
      opacity: 0;
    }
    &.none {
      transform: translateX(0px) scale(1);
      opacity: 1;
    }
  }

  p.cuona-nolabel-logo {
    display: block;
    background: url("../assets/cuona_nolabel_logo.svg") no-repeat center;
    width: 64px;
    height: 45px;
    margin: -120px auto 95px auto;
    transition: all .3s ease-in;

    &.show {
      transform: translateX(0px) scale(1);
      opacity: 1;
    }
    &.none {
      transform: translateX(30px) scale(1.2);
      opacity: 0;
    }
  }

  ul.el-menu ::v-deep {
    background: inherit;
    border-right: none;

    li {
      height: inherit;
      padding: 0;
      line-height: 50px;
      font-size: 16px;
      transition: all .3s;
      .el-submenu__title {
        font-size: 16px;
        color: rgba(255,255,255,0.6);
      }
      .el-submenu__title:hover,&.el-menu-item:hover {
        background-color: rgba(255,255,255,0.2);
        color: rgba(255,255,255,1.0);
      }
      &.is-active:not(.el-submenu) {
        background-color: rgba(255,255,255,0.2);
        a {
          color: rgba(255,255,255,1.0);
        }
      }
      a {
        display: block;
        height: 50px;
        line-height: 50px;
        padding: 0 20px;
        transition: all .3s;
        color: rgba(255,255,255,0.6);
        &:hover {
          color: rgba(255,255,255,1.0);
          i.menu-icon {
            opacity: 0.6;
          }
        }
        span {
          transition: opacity .2s ease;
        }
      }
      &.el-submenu {
        ul.el-menu {
          background: inherit;
          li.el-menu-item {
            line-height: 40px;
            height: 40px;
            a {
              display: block;
              height: 40px;
              line-height: 40px;
              padding: 0 0 0 10px;
            }
          }
        }
      }
    }
  }
  i.menu-icon {
    display: inline-block;
    font-size: 20px;
    width: 25px;
    height: 20px;
    opacity: 0.6;
  }
  i.icon-dashboard {
    background: url("../assets/icon_dashboard.svg") no-repeat 0 0;
  }
  i.icon-analysis {
    background: url("../assets/icon_analysis.svg") no-repeat 0 0;
  }
  i.icon-cuona {
    background: url("../assets/icon_cuona.svg") no-repeat 0 0;
  }
}

/* for popup menu */
ul.el-menu--popup {
  li {
    padding: 0;
    a {
      padding: 0;
      display: block;
    }
  }
}

</style>
